<template>
  <div class="header" :class="{ 'header--scrolled': getScrolledFromTop }">
    <div class="header__col">
      <div class="header__connection" v-if="isAuth">
        <span class="header__connection-label">Connection: </span>
        <span class="header__circle" :class="{ 'header__circle--online': getIsConnected }"></span>

        <!-- TODO: dedupe -->
        <template v-if="$route.name === 'game'">
          <span class="header__separator"></span>

          <span class="header__connection-label" v-tooltip.bottom-start="getRoomUsersAsString">
            Users in the game: {{ getRoomUsers.length }}
          </span>
        </template>

        <!-- TODO: dedupe -->
        <template v-if="$route.name === 'lobby'">
          <span class="header__separator"></span>

          <span class="header__connection-label" v-tooltip.bottom-start="getRoomUsersAsString">
            Users in the lobby: {{ getRoomUsers.length }}
          </span>
        </template>
      </div>
    </div>

    <div class="header__col">
      <avl-hamburger class="header__hamburger"></avl-hamburger>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('utils', ['getScrolledFromTop']),
      ...mapGetters('auth', ['isAuth']),
      ...mapGetters('socket', ['getIsConnected', 'getRoomUsers']),
      getRoomUsersAsString() {
        return this.getRoomUsers.map((u) => u.displayName).join('<br>');
      },
    },
  };
</script>

<style scoped lang="scss">
  .header {
    height: $header-height;
    width: 100%;
    //
    position: fixed;
    top: 0;
    left: 0;
    //
    pointer-events: none;

    & > * {
      pointer-events: all;
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      z-index: z('below-default');
      //
      height: 100%;
      width: 100%;
      //
      background: linear-gradient(to bottom, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
      opacity: 0;
      transition: opacity 400ms;
    }

    &--scrolled::before {
      opacity: 1;
    }

    &__hamburger {
      float: right;
    }

    &__col {
      display: inline-flex;
      vertical-align: middle;
      align-items: center;
      width: 50%;
      height: 100%;

      &:last-child {
        justify-content: flex-end;
      }
    }

    &__connection {
      white-space: nowrap;
      user-select: none;
      padding: 16px;
      color: white;
      //
      font-size: 10px;
      @include phone-lg() {
        font-size: 14px;
      }

      & > * {
        display: inline-block;
        vertical-align: middle;
      }
    }

    &__connection-label {
      margin-right: 6px;
      @include tablet-lg() {
        margin-right: 8px;
      }
    }

    &__circle {
      border: 1px solid #ffffff;
      border-radius: 50%;
      background: $red;
      //
      width: 8px;
      height: 8px;
      @include phone-lg() {
        width: 10px;
        height: 10px;
      }
      @include tablet-lg() {
        width: 12px;
        height: 12px;
      }

      &--online {
        background: $green;
      }
    }

    &__separator {
      width: 1px;
      background: #ffffff;
      //
      margin: 0 8px;
      height: 12px;
      @include phone-lg() {
        margin: 0 16px;
        height: 14px;
      }
      @include tablet-lg() {
        height: 16px;
      }
    }
  }
</style>
